import React from "react"
import { Box, Typography, Divider,  Card , CardContent, AppBar, Grid} from '@mui/material';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import SchoolIcon from "@mui/icons-material/School";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";


function Hero() {

  return (
    <Box sx={{ width: '100%', overflow: 'hidden'}}>
       <AppBar
                    position="static"
                    sx={{
                      background: 'linear-gradient(to right, #ff4635, #940000)',
                      boxShadow: 'none',
                      py: 1,
                      mt:5
                    }}
                  />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 10,
          alignItems: 'center',
          px: { xs: 2, md: 6 },
          py: { xs: 4, md: 6 },
          backgroundColor: '#f5f5f5', 
        }}
      >
        {/* IZQUIERDA - Card video */}
        <Box sx={{ width: { xs: '80%', md: '40%' } }}>
  <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
    
    <iframe
  width="100%"
  height="300"
  src="https://www.youtube.com/embed/F7jb7_9m-dE"
  title="Video Cámara Madrid"
  frameBorder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowFullScreen
  style={{ borderRadius: '12px 12px 0 0' }}
/>

    <CardContent>
      <Typography variant="h6">
        Campus Cámara Madrid
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Conoce nuestras instalaciones y espacios de formación.
      </Typography>
 

    </CardContent>

  </Card>
</Box>

        {/* DERECHA - Texto */}
   <Box
  sx={{
    width: { xs: '100%', md: '60%' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    textAlign: { xs: 'center', md: 'left' },
    pt: 0,
  }}
>
  <Typography
    variant="body1"
    sx={{
      color: 'text.secondary',
      lineHeight: 1.6,
      mb: 3,
    }}
  >
    Descubre nuestras modernas instalaciones de 14.000 m² y vive la experiencia de nuestro centro de formación.<br />
    Reserva tu visita de forma sencilla y personalizada, explorando nuestros espacios con la guía de nuestro equipo.<br />
    Prepárate en un ambiente profesional y planifica tu futuro con confianza.
  </Typography>

  <Divider
    sx={{
      mb: 2,
      mx: { xs: 'auto', md: 0 },
      width: { xs: '60%', md: '100%' },
    }}
  />

<Grid
  container
  direction="column"
  spacing={3}
  sx={{ mt: 1 }}
>
  <Grid item xs={12}>
    <Box sx={{ display: "flex", gap: 2 }}>
      <WorkspacePremiumIcon sx={{ color: "#c62828", fontSize: 32 }} />
      <Box>
        <Typography variant="subtitle1" fontWeight={600}>
          Experiencia y prestigio
        </Typography>
        <Typography variant="body2" color="text.secondary">
          +30 años formando profesionales reconocidos internacionalmente.
        </Typography>
      </Box>
    </Box>
  </Grid>

  <Grid item xs={12}>
    <Box sx={{ display: "flex", gap: 2 }}>
      <SchoolIcon sx={{ color: "#c62828", fontSize: 32 }} />
      <Box>
        <Typography variant="subtitle1" fontWeight={600}>
          Formación práctica
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Programas impartidos por profesionales en activo.
        </Typography>
      </Box>
    </Box>
  </Grid>

  <Grid item xs={12}>
    <Box sx={{ display: "flex", gap: 2 }}>
      <BusinessCenterIcon sx={{ color: "#c62828", fontSize: 32 }} />
      <Box>
        <Typography variant="subtitle1" fontWeight={600}>
          Oportunidades profesionales
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Convenios y bolsa de empleo para impulsar tu carrera.
        </Typography>
      </Box>
    </Box>
  </Grid>

  <Grid item xs={12}>
    <Box sx={{ display: "flex", gap: 2 }}>
      <SupportAgentIcon sx={{ color: "#c62828", fontSize: 32 }} />
      <Box>
        <Typography variant="subtitle1" fontWeight={600}>
          Asesoramiento personalizado
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Tutores que te acompañan durante todo el proceso formativo.
        </Typography>
      </Box>
    </Box>
  </Grid>
</Grid>
</Box>
      </Box>
    </Box>

  );
}

export default Hero;